var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-2" },
    [
      _c("Menu", {
        attrs: {
          items: _vm.organizedItems,
          groupProperty: _vm.group_property,
          ulClass: "nav nav-sidebar flex-column",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }